import * as React from 'react';
import ExtendedPropertyType from 'owa-service/lib/contract/ExtendedPropertyType';
import fetchMRUSuggestions from '../services/fetchMRUSuggestions';
import getPropertyFromItem from './getPropertyFromItem';
import getStore from '../store/store';
import loc from 'owa-localize';
import parseSmartDocProperty from './parseSmartDocProperty';
import SmartDocPill from '../components/SmartDocPill';
import { ClientItem } from 'owa-mail-store';
import { FeatureNames } from 'owa-mail-smart-pill-features';
import { GetItemManagerFeatureIds } from 'owa-mail-smart-pill-features';
import { IButtonStyles } from 'office-ui-fabric-react/lib/Button';
import { initializeSmartPillLogData, SmartPillData, SmartPillLogData } from 'owa-smart-pill';
import { lazyGetItemProperties } from 'owa-get-item-manager';
import { SMART_DOC_PROPERTY_NAME } from './constants';
import { smartDocButtonText } from './smartDocButton.locstring.json';

export default async function createSmartDocPills(item: ClientItem): Promise<SmartPillData[]> {
    // If there is a SendContentRequest property on the ClientItem but no EntityId, then there is no (valid)
    // property on the item indicating intent to upload an attachment, so abort.
    if (item.SmartDocData && !item.SmartDocData.EntityId) {
        return [];
    }

    // If property simply hasn't been fetched/parsed yet, do it now.
    if (!item.SmartDocData) {
        const getItemProperties = await lazyGetItemProperties.import();
        const itemWithProperty: ClientItem = (await getItemProperties(
            item.ItemId.Id,
            GetItemManagerFeatureIds.SmartDoc
        )) as ClientItem;

        // At this point, if itemWithProperty exists, it should be the same as the item input into this function.
        if (itemWithProperty) {
            const extendedProperty: ExtendedPropertyType = getPropertyFromItem(
                itemWithProperty,
                SMART_DOC_PROPERTY_NAME
            );

            parseSmartDocProperty(itemWithProperty, extendedProperty);
        }
    }

    if (item.SmartDocData?.EntityId) {
        return [createSmartPillForAttachmentSuggestions(item)];
    } else {
        return [];
    }
}
function createSmartPillForAttachmentSuggestions(item: ClientItem): SmartPillData {
    const logData: SmartPillLogData = initializeSmartPillLogData(
        FeatureNames.SmartDoc,
        'Attach a file'
    );

    // For now just use contextual MRU suggestions.
    // The fetch requst will be async, and the data will be populated into the SmartPill after
    // the request has been processed.
    fetchMRUSuggestions(item.ItemId.Id);

    // Since the SmartPillData has a customized render, all other fields provided here will not be used,
    // so we just keep the requried fields here.
    return {
        onRender: (position: number, style: IButtonStyles): React.ReactNode => {
            return (
                <SmartDocPill
                    store={getStore()}
                    item={item}
                    logData={logData}
                    position={position}
                    menuItemStyle={style}
                />
            );
        },
        ariaLabel: loc(smartDocButtonText),
        featureName: FeatureNames.SmartDoc,
        index: 0,
        logData: logData,
        onClick: null,
    };
}
